/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccountDeletionTaskSearchStatus } from './';
import {
    AccountDeletionTaskSearchStatusFromJSON,
    AccountDeletionTaskSearchStatusFromJSONTyped,
    AccountDeletionTaskSearchStatusToJSON,
} from './';
import type { AccountDeletionTasksSearchRequestOrderedBy } from './';
import {
    AccountDeletionTasksSearchRequestOrderedByFromJSON,
    AccountDeletionTasksSearchRequestOrderedByFromJSONTyped,
    AccountDeletionTasksSearchRequestOrderedByToJSON,
} from './';
import type { AccountDeletionWorkflowType } from './';
import {
    AccountDeletionWorkflowTypeFromJSON,
    AccountDeletionWorkflowTypeFromJSONTyped,
    AccountDeletionWorkflowTypeToJSON,
} from './';
import type { DateTimeBetween } from './';
import {
    DateTimeBetweenFromJSON,
    DateTimeBetweenFromJSONTyped,
    DateTimeBetweenToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountDeletionTasksSearchRequest
 */
export interface AccountDeletionTasksSearchRequest {
    /**
     * 
     * @type {AccountDeletionWorkflowType}
     * @memberof AccountDeletionTasksSearchRequest
     */
    workflowType?: AccountDeletionWorkflowType;
    /**
     * 
     * @type {AccountDeletionTaskSearchStatus}
     * @memberof AccountDeletionTasksSearchRequest
     */
    status?: AccountDeletionTaskSearchStatus;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTasksSearchRequest
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTasksSearchRequest
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTasksSearchRequest
     */
    identityId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDeletionTasksSearchRequest
     */
    emailAddress?: string;
    /**
     * 
     * @type {DateTimeBetween}
     * @memberof AccountDeletionTasksSearchRequest
     */
    creationDateTime?: DateTimeBetween;
    /**
     * 
     * @type {DateTimeBetween}
     * @memberof AccountDeletionTasksSearchRequest
     */
    lastStatusChangeDateTime?: DateTimeBetween;
    /**
     * The ID of task until after which all tasks must be skipped, when fetching the result page.
     * @type {string}
     * @memberof AccountDeletionTasksSearchRequest
     */
    comingAfterTaskId?: string;
    /**
     * 
     * @type {AccountDeletionTasksSearchRequestOrderedBy}
     * @memberof AccountDeletionTasksSearchRequest
     */
    orderedBy?: AccountDeletionTasksSearchRequestOrderedBy;
}

/**
 * Check if a given object implements the AccountDeletionTasksSearchRequest interface.
 */
export function instanceOfAccountDeletionTasksSearchRequest(value: object): value is AccountDeletionTasksSearchRequest {
    return true;
}

export function AccountDeletionTasksSearchRequestFromJSON(json: any): AccountDeletionTasksSearchRequest {
    return AccountDeletionTasksSearchRequestFromJSONTyped(json, false);
}

export function AccountDeletionTasksSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionTasksSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowType': json['workflowType'] == null ? undefined : AccountDeletionWorkflowTypeFromJSON(json['workflowType']),
        'status': json['status'] == null ? undefined : AccountDeletionTaskSearchStatusFromJSON(json['status']),
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
        'emailAddress': json['emailAddress'] == null ? undefined : json['emailAddress'],
        'creationDateTime': json['creationDateTime'] == null ? undefined : DateTimeBetweenFromJSON(json['creationDateTime']),
        'lastStatusChangeDateTime': json['lastStatusChangeDateTime'] == null ? undefined : DateTimeBetweenFromJSON(json['lastStatusChangeDateTime']),
        'comingAfterTaskId': json['comingAfterTaskId'] == null ? undefined : json['comingAfterTaskId'],
        'orderedBy': json['orderedBy'] == null ? undefined : AccountDeletionTasksSearchRequestOrderedByFromJSON(json['orderedBy']),
    };
}

export function AccountDeletionTasksSearchRequestToJSON(value?: AccountDeletionTasksSearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowType': AccountDeletionWorkflowTypeToJSON(value['workflowType']),
        'status': AccountDeletionTaskSearchStatusToJSON(value['status']),
        'accountId': value['accountId'],
        'companyId': value['companyId'],
        'identityId': value['identityId'],
        'emailAddress': value['emailAddress'],
        'creationDateTime': DateTimeBetweenToJSON(value['creationDateTime']),
        'lastStatusChangeDateTime': DateTimeBetweenToJSON(value['lastStatusChangeDateTime']),
        'comingAfterTaskId': value['comingAfterTaskId'],
        'orderedBy': AccountDeletionTasksSearchRequestOrderedByToJSON(value['orderedBy']),
    };
}

